import {__} from "./__";

export const getPacks = (courier_id) => {
    if (courier_id === 7) {
        return {
            package: __('Balík'),
            palette_euro: __('Europaleta'),
            palette_standard: __('Štandard paleta'),
            palette_half: __('Pol paleta'),
            palette_standard_half: __('Štandard pol paleta'),
            palette_quarter: __('Štvrť paleta'),
            palette_double: __('Dvojpaleta'),
            palette_other: __('Paleta iných rozmerov'),
        };
    }

    return {
        package: __('Balík'),
        palette_euro: __('Europaleta'),
        palette_standard: __('Štandard paleta'),
        palette_half: __('Polopaleta'),
        letter: __('List'),
    };
};
